<div class="settings-modal-dialog__wrapper">
  <div class="settings-modal-dialog__top">
    <div mat-dialog-title>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="fal fa-cog i-16 mr-4"></i>
          <span>Settings</span>
        </div>
        <div>
          <button trgButton class="dialog-close-btn" (click)="close()">
            <i class="fal fa-times i-12 p-relative ot-1"></i>
          </button>
        </div>
      </div>
    </div>
    <div mat-dialog-content>
      <div class="settings-section">
        <div class="settings-section__header">
          <span class="fs-14 bold c-blue">Details</span>
        </div>
        <div class="settings-section__group">
          <label>Name:</label>
          <div class="settings-section__input">
            <span>{{ getNameOrDefault() }}</span>
          </div>
        </div>
        <div class="settings-section__group mb-10 pr-50">
          <label class="settings-section-input-offset">Subtitle:</label>
          <div class="settings-section__input">
            <textarea matInput
                      class="trg-outline w-100p max-h-100"
                      [maxlength]="limits.subtitleMaxLength"
                      rows="2"
                      style="resize: none"
                      [formControl]="visualEditor.subtitle.control"></textarea>
          </div>
        </div>
        <div class="settings-section__group mb-10 pr-50">
          <label class="settings-section-input-offset">Description:</label>
          <div class="settings-section__input">
            <textarea matInput
                      class="trg-outline w-100p max-h-100"
                      [maxlength]="limits.descriptionMaxLength"
                      rows="4"
                      style="resize: none"
                      [formControl]="visualEditor.description.control"></textarea>
          </div>
        </div>

        <ng-container *ngIf="user().isSuperAdmin">
          <div class="settings-section__group mb-10 pr-50">
            <label class="settings-section-input-offset">Categories:</label>
            <div class="settings-section__input">
              <mat-select multiple
                          class="trg-outline"
                          panelClass="trg-outline-dropdown"
                          [formControl]="visualEditor.categoryIds.control">
                <mat-option *ngFor="let category of itemCategories()" [value]="category.id">
                  <ng-template *ngTemplateOutlet="itemCategoryOption; context: { category, icon: category.icon }"></ng-template>
                </mat-option>
              </mat-select>
              <ng-template #itemCategoryOption let-category="category" let-icon="icon">
                <div class="d-flex w-100p">
                  <img *ngIf="icon" src="icon.url" alt="" />
                  <span>{{ category.formattedName }}</span>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="settings-section__group pr-50">
            <label class="settings-section-input-offset">Owner:</label>
            <div class="settings-section__input">
              <mat-select class="trg-outline"
                          panelClass="trg-outline-dropdown"
                          [formControl]="visualEditor.createdBy.control">
                <mat-option *ngFor="let owner of owners()" [value]="owner.username">{{ owner.username }}</mat-option>
              </mat-select>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="settings-section" *ngIf="isUserDataset()">
        <div class="settings-section__header">
          <span class="fs-14 bold c-blue">User Dataset</span>
        </div>
        <div class="settings-section__group">
          <label class="text-right">Name:</label>
          <div class="settings-section__input">
            <span>{{ userDatasetDto().name }}</span>
          </div>
        </div>
        <div class="settings-section__group" *ngIf="allowProfilingUserDataset()">
          <label class="text-right">Profiling:</label>
          <div class="settings-section__input">
            <trg-checkbox [value]="userDatasetDto().profile" (valueChange)="setUserDatasetProfiling(!userDatasetDto().profile)"></trg-checkbox>
            <span class="fs-10 ml-4">*Change applies immediately</span>
          </div>
        </div>
        <div class="settings-section__group">
          <label class="text-right">Last Refresh:</label>
          <div class="settings-section__input">
            <span>
              {{
          settingRefreshDetails().DetailsReady && !userDatasetLoadFailed()
            ? (settingRefreshDetails().LastRefreshed | dateWithTimezone: localisationService.CUSTOM_DATE_FORMATS.mediumDateTimeNoSeconds)
            : "Not Refreshed"
              }}
            </span>
            <i *ngIf="userDatasetLoadFailed()"
               class="fas fa-exclamation-triangle c-orange ml-4"
               title="The extended dataset has failed to load in the last refresh."></i>
          </div>
        </div>
        <ng-container *ngIf="!userDatasetRefreshLog()?.legacy">
          <div class="settings-section__group">
            <label class="text-right">Last Refresh By:</label>
            <div class="settings-section__input">
              <span>{{ settingRefreshDetails().DetailsReady ? settingRefreshDetails().LastRefreshedBy : "Not Refreshed" }}</span>
            </div>
          </div>
          <div class="settings-section__group" [class.mb-10]="refreshDetails">
            <label class="text-right">Refresh Duration:</label>
            <div class="settings-section__input">
              <div>
                <div class="d-flex" [class.refresh-duration-section-expanded]="refreshDetails">
                  <div>
                    {{ settingRefreshDetails().DetailsReady ? settingRefreshDetails().RefreshDuration : "Not Refreshed" }}
                  </div>
                  <div class="d-flex p-relative" style="top: 2px" *ngIf="settingRefreshDetails().DetailsReady">
                    <div *ngIf="!settingRefreshDetails().LongDuration" class="fs-13 italic">
                      {{ settingRefreshDetails().LongDuration ? "hh:mm:ss" : "mm:ss" }}
                    </div>
                    <a *ngIf="refreshDetails()" class="ml-10 fs-11 pointer settings-section__input__details" (click)="setRefreshDetails(false)">
                      <i class="fas fa-chevron-square-up"></i>
                      Hide Detail
                    </a>
                    <a *ngIf="!refreshDetails()" class="ml-10 fs-11 pointer settings-section__input__details" (click)="setRefreshDetails(true)">
                      <i class="fas fa-chevron-square-down"></i>
                      Show Detail
                    </a>
                  </div>
                </div>
                <div *ngIf="refreshDetails()" class="mt-5 d-flex flex-dir-column" style="width: 200px">
                  <div class="d-flex justify-content-between mb-5">
                    <span class="fs-11 ml-10">1. Connection</span>
                    <span class="fs-11">{{ settingRefreshDetails().ConnectionTime }}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-5">
                    <span class="fs-11 ml-10">2. Execution</span>
                    <span class="fs-11">{{ settingRefreshDetails().ExecutionTime }}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-5">
                    <span class="fs-11 ml-10">3. Data Transfer</span>
                    <span class="fs-11">{{ settingRefreshDetails().DataTransferTime }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span class="fs-11 ml-10">4. Final Preparation</span>
                    <span class="fs-11">{{ settingRefreshDetails().FinalPreparationTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="settings-section__group mb-10">
          <label class="text-right settings-section-input-offset">Cache Duration:</label>
          <div class="settings-section__input">
            <input class="trg-outline h-28 lh-28"
                   type="number"
                   min="{{ 1 }}"
                   max="{{ 365 }}"
                   [disabled]="busy()"
                   [ngModel]="userDatasetCacheDuration()"
                   (ngModelChange)="setUserDatasetCacheDuration($event)"
                   (input)="validateCacheDuration($event)" />
            <span class="ml-2 fs-11 italic">Day(s) &#x2022; Cache Duration may be overridden by API calls & Scheduled Items</span>
          </div>
        </div>
        <div class="settings-section__group">
          <label class="text-right">Next Data Purge:</label>
          <div class="settings-section__input">
            <span>
              {{
          userDatasetNextPurgeOn()
            ? (userDatasetNextPurgeOn() | dateWithTimezone: localisationService.CUSTOM_DATE_FORMATS.mediumDateTimeNoSeconds)
            : "Not Scheduled"
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end" class="settings-modal-dialog__bottom">
    <button trgButton color="outline" class="min-w-70" (click)="close()">Close</button>
  </div>
</div>